module.exports = __webpack_public_path__ + "img/pizza_prosciuto.bb9f80fb.jpg";